import Api from "entities/helpers/api";
import EverTrue from "app";
import ErrorLogger from "entities/helpers/error-log-helper";
import journeysQueries from "../gql/queries";
import { fetchFromGraphql } from "entities/helpers/gqlCall";
import { getUserContactIdForOrg } from "../helpers";

export const bulkFetchContactsForJourney = async (contactIds) => {
  const query = journeysQueries.fetchContacts;

  const params = { ids: contactIds };
  const { contacts } = await fetchFromGraphql(query, params, "contacts");

  return contacts;
};

// moveConstituentToJourneyStage should be deprecated and replaced with moveConstituentToJourney when we are able to finally remove assignments

const fetchStageGroup = async () => {
  const gql = String.raw;
  const query = gql`
    query ($type: Int!) {
      stage_group(type: $type) {
        id
        stages {
          id
          stage
          journeyId
        }
      }
    }
  `;
  const queryVars = { type: 3 };

  const { stage_group } = await fetchFromGraphql(query, queryVars, "stage_group");

  return stage_group || { stages: [] };
};

export const moveConstituentToJourneyStage = async (prospect_contact_id, newJourneyId, user, org) => {
  try {
    const stageGroup = await fetchStageGroup();
    const { id: stage_id, stage } = stageGroup.stages.find((s) => s.journeyId === newJourneyId);
    let solicitor_contact_id = getUserContactIdForOrg(user, org);
    if (solicitor_contact_id) solicitor_contact_id = Number(solicitor_contact_id);

    const requestBody = {
      prospect_contact_id,
      solicitor_contact_id,
      stage_group_id: stageGroup.id,
      stage_id,
    };

    return await Api.ASSIGNMENTS.UPDATE_JOURNEY_STAGE.request({
      type: "PUT",
      data: JSON.stringify(requestBody),
      success: () => {
        if (stage === "Inactive") {
          return EverTrue.Alert.success(
            "Successfully removed constituent from cadence. Constituent can be accessed from the Inactive menu."
          );
        }
        return EverTrue.Alert.success(`Successfully moved constituent into ${stage} cadence.`);
      },
      error() {
        return EverTrue.Alert.error("Could not move constituents. Please try again.");
      },
    });
  } catch (error) {
    console.error("Error moving constituents to a cadence:", error);
  }
};

export const moveConstituentToJourney = async (oldJourneyId, contactId, userId, oid, newJourneyId, newJourneyLabel) => {
  const payload = {
    contact_id: contactId,
    user_id: userId,
    oid: oid,
  };
  if (newJourneyId) payload.new_journey = { id: newJourneyId };
  if (oldJourneyId)
    payload.old_journey = {
      id: oldJourneyId,
      reason: newJourneyId ? "SKIPPED_MOVED_JOURNEY" : "SKIPPED_REMOVED_FROM_JOURNEY",
    };
  await Api.JOURNEYS.CONTACT_JOURNEY.post({
    data: JSON.stringify(payload),
    success: () => {
      if (payload.new_journey) {
        return EverTrue.Alert.success(`Successfully moved constituent into ${newJourneyLabel} cadence.`);
      }
      return EverTrue.Alert.success("Successfully removed constituent from cadence.");
    },
    error: (e) => {
      ErrorLogger.error("Error moving constituent", { extra: { error: e, page_name: "Cadences" } });
    },
  });
};

// TO DO: Update to a bulk add endpoint
export const bulkAddConstituentsToJourney = async (contactId, userId, oid, newJourneyId) => {
  const payload = {
    contact_id: contactId,
    user_id: userId,
    oid: oid,
    new_journey: { id: newJourneyId },
  };
  await Api.JOURNEYS.CONTACT_JOURNEY.post({
    data: JSON.stringify(payload),
  });
};

export const getContactJourney = async (contactId) => {
  try {
    return await Api.JOURNEYS.GET_CONTACT_JOURNEY.get({
      urlArgs: { contact_id: contactId },
    });
  } catch (e) {
    ErrorLogger.error("EError fetching Contact's Journey details", { extra: { error: e, page_name: "Profile Header" } });
  };
}
